import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    subtitle: 'Only a few more seconds...',
    title: 'Pending order!',
  },
  fr: {
    subtitle: 'Plus que quelques secondes...',
    title: 'Commande en cours!',
  } as const,
});

export default locales;
